var /* UP
-------------------------------------------------- */ _document_querySelector, /* BUY MODAL
-------------------------------------------------- */ _document_querySelector1, /* HOME CURSOR
-------------------------------------------------- */ _document_querySelectorAll;
import Route from '../components/route';
import '../components/slider';
import Infrastructure from '../components/infrastructure';
import Metro from '../components/metro';
import '../components/range';
import '../components/filters-row';
import '../components/filters-show';
import '../components/promotion';
import Accordion from '../components/accordion';
import Building from '../components/building';
import Mortgage from '../components/mortgage';
import Kellers from '../components/kellers';
import parking from '../components/parking';
import GalleryTabs from '../components/gallery-tabs';
import Finish from '../components/finish';
import RowHover from '../components/row-hover';
import { device } from '../helpers';
import '../components/search-search';
import '../components/search-tabs';
import SearchTower from '../components/search-tower';
var route = new Route();
route.init();
var kellers = new Kellers();
kellers.init();
var rowHover = new RowHover();
rowHover.init();
var infrastructure = new Infrastructure();
infrastructure.init();
var metro = new Metro();
metro.init();
var searchTower = new SearchTower();
searchTower.init();
var accordion = new Accordion();
accordion.init();
if (typeof buildingData !== 'undefined') {
    var building = new Building();
    building.init();
}
var mortgage = new Mortgage();
mortgage.init();
var galleryTabs = new GalleryTabs();
galleryTabs.init();
var finish = new Finish();
finish.init();
/* HEADER
-------------------------------------------------- */ var $header = document.querySelector('.header');
$header.classList.toggle('header_transparent', window.scrollY <= 0);
var bottomFirstScreen = document.querySelector('.hero').getBoundingClientRect().bottom;
$header.classList.toggle('header_transparent', window.scrollY <= 0);
$header.classList.toggle('header_first', bottomFirstScreen >= window.scrollY);
document.addEventListener('scroll', function() {
    $header.classList.toggle('header_transparent', window.scrollY <= 0);
    $header.classList.toggle('header_first', bottomFirstScreen >= window.scrollY);
});
(_document_querySelector = document.querySelector('[data-up]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.addEventListener('click', function(event) {
    event.preventDefault();
    window.lenis.scrollTo('start', {});
});
(_document_querySelector1 = document.querySelector('[data-buy-request]')) === null || _document_querySelector1 === void 0 ? void 0 : _document_querySelector1.addEventListener('click', function(event) {
    event.preventDefault();
    document.querySelector('[data-buy-type]').value = document.querySelector('[data-accordion-item].-show').querySelector('.buy__heading span').innerText;
    window.modal.open('buy-request');
});
(_document_querySelectorAll = document.querySelectorAll('.home-preview')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function($item, index) {
    if (!device.isTouch()) {
        $item.addEventListener('mouseenter', function() {
            $item.insertAdjacentHTML('beforeend', '\n				<div class="home-preview__cursor">\n					<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 80 80">\n						<path fill="#fff" d="M41.6 75h-2V41.6H5v-2h34.6V5h2v34.6H75v2H41.6z"/>\n					</svg>\n				</div>\n			');
        });
        $item.addEventListener('mousemove', function(event) {
            var $cursor = $item.querySelector('.home-preview__cursor');
            if ($cursor) {
                $cursor.style.top = "".concat(event.offsetY, "px");
                $cursor.style.left = "".concat(event.offsetX, "px");
            }
        });
        $item.addEventListener('mouseleave', function() {
            var _$item_querySelector;
            (_$item_querySelector = $item.querySelector('.home-preview__cursor')) === null || _$item_querySelector === void 0 ? void 0 : _$item_querySelector.remove();
        });
    }
    $item.addEventListener('click', function() {
        window.modal.open('home-slider');
        window.sliderHome.slideTo(index, 0);
        window.sliderHome.update();
    });
});
var parentElement = document.getElementById('advantages-swiper');
var videoElement = document.createElement('video');
videoElement.id = "parkVideo";
videoElement.poster = './assets/img/poster.webp';
var play = document.createElement('div');
// Присвойте элементу идентификатор (id)
play.id = 'playVideo';
// Установите атрибуты видео, например, источник и тип
videoElement.src = './assets/img/park.mp4';
videoElement.type = 'video/mp4';
parentElement.children[3].appendChild(videoElement);
parentElement.children[3].appendChild(play);
var video = document.getElementById('parkVideo');
var videoId = document.getElementById('playVideo');
videoId.addEventListener('click', function() {
    videoId.classList.add('hidden');
    video.play();
});
video.addEventListener('click', function() {
    if (video.paused) {
        video.play();
        videoId.classList.add('hidden');
    } else {
        video.pause();
        videoId.classList.remove('hidden');
    }
});
function updateCountdown(element, endTime) {
    var now = new Date().getTime();
    var distance = endTime - now;
    if (distance < 0) {
        element.textContent = "00:00:00";
        return;
    }
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(distance % (1000 * 60) / 1000);
    days = days < 10 ? "0" + days : days;
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    element.querySelector('.room__counter-wrap').innerHTML = '\n                          <div class="room__counter-wrap-number">\n                            <div id="day" class="room__counter-wrap-number-d">'.concat(days, '</div>\n                            <div id="day-d" class="room__counter-wrap-number-n">дней</div>\n                          </div>\n                          :\n                          <div class="room__counter-wrap-number">\n                            <div id="hour" class="room__counter-wrap-number-d">').concat(hours, '</div>\n                            <div id="hour-d" class="room__counter-wrap-number-n">час</div>\n                          </div>\n                          :\n                          <div class="room__counter-wrap-number">\n                            <div  id="minute" class="room__counter-wrap-number-d">').concat(minutes, '</div>\n                            <div  id="minute-d" class="room__counter-wrap-number-n">Мин.</div>\n                          </div>\n                          :\n                          <div class="room__counter-wrap-number">\n                            <div id="second"  class="room__counter-wrap-number-d">').concat(seconds, '</div>\n                            <div id="second-d" class="room__counter-wrap-number-n">Сек.</div>\n                          </div>\n                        ');
}
function initializeCountdowns() {
    var countdownElements = document.querySelectorAll('.room__counter');
    var currentDate = new Date();
    countdownElements.forEach(function(element) {
        var startDate = new Date(element.getAttribute('startDate'));
        var endDate = new Date(element.getAttribute('endDate'));
        if (currentDate >= startDate && currentDate <= endDate) {
            element.classList.add("active");
            updateCountdown(element, endDate);
            setInterval(function() {
                updateCountdown(element, endDate);
            }, 1000);
        } else {
            element.classList.remove("active");
        }
    });
}
function addJSClassToParents() {
    // Получаем все элементы на странице
    var allElements = document.querySelectorAll('.room-preview__title');
    // Проходим по всем элементам
    for(var i = 0; i < allElements.length; i++){
        var element = allElements[i];
        var parentElement = element.parentNode;
        var childElementByClass = parentElement.parentNode.querySelector('.room-preview__tags span');
        var childText = childElementByClass.textContent;
        var text = element.textContent;
        var numbersOnly = parseInt(text.replace(/\D/g, ""));
    // if(numbersOnly===942||numbersOnly===947||numbersOnly===1032||numbersOnly===593||numbersOnly===1093||numbersOnly===1078||numbersOnly===1061||numbersOnly===782){
    // 	if (parentElement && !parentElement.classList.contains('active')) {
    // 		parentElement.classList.add('active');
    // 	}
    // }
    }
} //   setInterval(function() {
 // 		addJSClassToParents();
 // 		initializeCountdowns();
 // }, 2000);
